import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { MarketStrip } from '../components/MarketStrip';
import { HeroSection } from '../components/HeroSection';
import { BottomArticles } from '../components/BottomArticles';
import { AdPlaceholder } from '../components/AdPlaceholder';
export function Home2() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-490">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-491">
        <Header data-id="element-492" />
        <Navigation data-id="element-493" />

        {/* Top Banner Ad — above ticker in this variant */}
        <div className="py-4 md:py-6 flex justify-center" data-id="element-494">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[50px] md:h-[90px]" text="Wenda Ingredients Advertisement" data-id="element-495" />
        </div>
      </div>

      {/* Full-width ticker bar — below the ad banner */}
      <MarketTicker data-id="element-496" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-497">
        <div className="pt-6" data-id="element-498" />
        <main data-id="element-499">
          <HeroSection data-id="element-500" />
          <BottomArticles data-id="element-501" />
          <MarketStrip data-id="element-502" />
        </main>

        {/* Bottom Banner Ad */}
        <div className="py-8 border-t border-gray-200 flex justify-center" data-id="element-503">
          <AdPlaceholder width="w-full max-w-[970px]" height="h-[50px] md:h-[90px]" text="Intralox Advertisement" data-id="element-504" />
        </div>
      </div>
    </div>;
}